import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { OMNI_22XX_MODAL_TYPE, modalTypeForTypeName } from '../helpers/sensor-type-names';

@Injectable({
   providedIn: 'root',
})
export class SensorModalTypeService {
   constructor(private _httpService: HttpService) {}

   /**
    * Config modal type for a sensor's SensorTypes_* record, read once per call (not cached).
    * A missing id or record resolves to 2; a read error is passed on so callers never
    * write a guessed modal type.
    */
   modalTypeFor(sensorTypeId?: string): Observable<number> {
      if (!sensorTypeId) {
         return of(OMNI_22XX_MODAL_TYPE);
      }
      return this._httpService
         .getAsObject(`${environment.APIS.SENSORTYPES}/${sensorTypeId}`, 1)
         .pipe(map(sensorType => modalTypeForTypeName(sensorType?.typeName)));
   }
}
